import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { selectHasPushError } from '@ff-os/pdp-shared-redux/slices/snapshotSlice';
import { Alert } from '@ff-os/shared-react/components/alert/Alert';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';

const _PhotoPrintsWindowErrors = ({ hasPushError }: Props) => {

    const { t } = useTranslation();
    const [hasError, setHasError] = useState(hasPushError);

    useEffect(() => {
        setHasError(hasPushError);
    }, [hasPushError]);

    return (
        <>
            {hasError && (
                <Alert icon='alert-triangle-exclamation' type='error' onDismiss={() => setHasError(false)}>
                    {t('order_button.error_message')}
                </Alert>
            )}
        </>
    );
};

type Props = {
    hasPushError: boolean;
};

const mapStateToProps = (state: PhotoPrintsPdpState) => ({
    hasPushError: selectHasPushError(state)
});

export const PhotoPrintsWindowErrors = connect(
    mapStateToProps
)(_PhotoPrintsWindowErrors);